import React from 'react';
import { registerApplicationElement } from '@markit/web-component-bootstrap';

import { standardMountToElementBuilder } from 'WebComponentEntryPoints/common';
import MarketsNewsHeadlines from 'Views/MarketsCentre/Modules/MarketsNews/MarketsNewsHeadlines';

export default () => {
	registerApplicationElement(
		'md-markets-news-headlines',
		{
			mountToElement: standardMountToElementBuilder(<MarketsNewsHeadlines />)
		}
	);
};
